export default "__VITE_ASSET__DEDyi_2D__"